/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SqliteFileUpload
 */
export interface SqliteFileUpload {
  /**
   *
   */
  readonly putUrl?: string;
  /**
   *
   */
  filename: string;
  /**
   *
   */
  readonly status?: string;
  /**
   *
   */
  md5sum?: string;
}

/**
 * Check if a given object implements the SqliteFileUpload interface.
 */
export function instanceOfSqliteFileUpload(value: object): value is SqliteFileUpload {
  if (!("filename" in value) || value["filename"] === undefined) return false;
  return true;
}

export function SqliteFileUploadFromJSON(json: any): SqliteFileUpload {
  return SqliteFileUploadFromJSONTyped(json, false);
}

export function SqliteFileUploadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SqliteFileUpload {
  if (json == null) {
    return json;
  }
  return {
    putUrl: json["put_url"] == null ? undefined : json["put_url"],
    filename: json["filename"],
    status: json["status"] == null ? undefined : json["status"],
    md5sum: json["md5sum"] == null ? undefined : json["md5sum"],
  };
}

export function SqliteFileUploadToJSON(json: any): SqliteFileUpload {
  return SqliteFileUploadToJSONTyped(json, false);
}

export function SqliteFileUploadToJSONTyped(
  value?: Omit<SqliteFileUpload, "putUrl" | "status"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    filename: value["filename"],
    md5sum: value["md5sum"],
  };
}
